import React from 'react';
import AuthCard from '../components/AuthCard';

const Login = () => <AuthCard mode="signin" />;

export default Login;
